import axios, { AxiosResponse, CancelToken } from "axios"
import { InsertTicketCommandProps } from "./Commands/InsertTicketCommand"
import { UpdateTicketCommandProps } from "./Commands/UpdateTicketCommand"
import { GetTicketsByFiltersDtoProps } from "./DTOs/GetTicketsByFiltersDto"
import { GetTicketsByIdDto } from "./DTOs/GetTicketsByIdDto"
import { GetTicketsByFiltersDtoIPagedEnumerableProps } from "./Schemas/GetTicketsByFiltersDtoIPagedEnumerable"
import { getTicketsByFilterAdapter } from "./Ticket.adapter"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export async function insertTicket(
  ticket: InsertTicketCommandProps
): Promise<AxiosResponse> {
  const resp = await axios.post("/ticket", ticket)
  return resp
}

export async function ticketById(id: string): Promise<GetTicketsByIdDto> {
  const { data }: { data: GetTicketsByIdDto } = await axios.get(`/Ticket/${id}`)
  return data
}
export interface TicketParamsProps {
  Categorias?: Array<string>
  EsReembolso?: boolean
  FechaEmisionLowerLimit?: string
  FechaEmisionUpperLimit?: string
  ImporteLowerLimit?: number
  ImporteUpperLimit?: number
  Keyword?: string
  SortingCriteria: SortingCriteria
  MaxResultCount?: number
  SkipCount?: number
}

export async function getTicketsByFilter(
  queryParams?: TicketParamsProps,
  cancelToken?: CancelToken
): Promise<GetTicketsByFiltersDtoIPagedEnumerableProps> {
  const { data } = await axios.get("/ticket", {
    params: queryParams,
    cancelToken,
  })
  return {
    currentPage: data.currentPage,
    items: data.items?.map((ticket: GetTicketsByFiltersDtoProps) =>
      getTicketsByFilterAdapter(ticket)
    ),
    totalCount: data.totalCount,
  }
}

export async function deleteTicket(id: string): Promise<AxiosResponse> {
  const response = await axios.delete(`/ticket/${id}`)
  return response
}

export async function updateTicket(
  ticket: UpdateTicketCommandProps
): Promise<AxiosResponse> {
  const response = await axios.put(`/ticket/${ticket.id}`, ticket)
  return response
}
